
import {
	SET_ORDERS,
	SET_ORDERS_META,
	SET_RESERVATIONS,
	SET_RESERVATIONS_META,
	SET_RETURNING_ORDERS,
	SET_RETURNING_ORDERS_META,
	SET_SUPPLIER_ORDERS,
	SET_SUPPLIER_ORDERS_META,
	SET_CARTS,
	SET_CARTS_META,
	EDIT_ORDER,
	EDIT_RESERVATION,
	SET_ORDER,
	SET_RETURNIG_ORDER,
	ADD_ORDER,
	SET_ORDERS_PRODUCTS,
	SET_ORDERS_PRODUCTS_META,
	SET_RETURNING_ORDERS_PRODUCTS_META,
	SET_RETURNING_ORDERS_PRODUCTS,
	RESET_ORDER_PRODUCTS,
	SET_ORDER_PRODUCTS_META,
	SET_ORDER_PRODUCTS,
	SET_RESERVATION,
	SET_RESERVATION_PRODUCTS_META,
	SET_RESERVATION_PRODUCTS,
	SET_RESERVATION_PRODUCTS_BACKUP,
	SET_RETURNING_ORDER_PRODUCTS_META,
	SET_RETURNING_ORDER_PRODUCTS,
	SET_RETURNING_ORDER_PRODUCTS_BACKUP,
	REMOVE_RETURNING_ORDER_PRODUCT,
	RESET_RETURNING_ORDER_PRODUCTS,
	REMOVE_ORDER_PRODUCT,
	SET_SEARCH_FILTERS,
	SET_LOADING,
	UPDATE_RETURN_INFORMATION,
	RESET_RETURN_INFORMATION,
	SET_DIMENSIONS,
	SET_ORDER_PRODUCTS_BACKUP,
	SET_TRACKING_HISTORY,
	SET_ORDERS_STATISTICS,
	SET_ORDERS_PRODUCTS_COLUMNS,
	SET_ORDERS_PRODUCTS_ORIGINAL_COLUMNS,
	SET_ORDERS_PRODUCTS_SORT_ORDER,
	SET_ORDERS_PRODUCTS_SORT_BY,
	SET_SUPPLIER_ORDER_PRODUCTS,
	SET_SUPPLIER_ORDER_SEARCH_FILTERS,
	EDIT_RETURNING_ORDER
} from './mutation-types'

export default {
	[SET_LOADING] (state, loading) {
		state.loading = { ...state.loading, ...loading }
	},

	[SET_ORDERS_PRODUCTS_COLUMNS] (state, columns) {
		state.ordersProductsColumns = columns
	},
	[SET_SUPPLIER_ORDER_PRODUCTS] (state, data) {
		state.supplierOrderProducts = data
	},
	[SET_ORDERS_PRODUCTS_SORT_ORDER] (state, sortOrder) {
		state.ordersProductsSortOrder = sortOrder
	},
	[SET_ORDERS_PRODUCTS_SORT_BY] (state, sortBy) {
		if (state.ordersProductsSortBy === sortBy) {
			if (state.ordersProductsSortOrder === 'desc') {
				state.ordersProductsSortOrder = 'asc'
			} else {
				state.ordersProductsSortOrder = 'desc'
			}
		} else {
			state.ordersProductsSortOrder = 'desc'
		}
		state.ordersProductsSortBy = sortBy
	},
	[SET_ORDERS_PRODUCTS_ORIGINAL_COLUMNS] (state, columns) {
		state.ordersProductsOriginalColumns = columns
	},

	[SET_TRACKING_HISTORY] (state, data) {
		state.trackingHistory = data
	},

	[SET_ORDERS_STATISTICS] (state, data) {
		state.statistics = data
	},

	[SET_DIMENSIONS] (state, dimensions) {
		state.dimensions = dimensions
	},

	[UPDATE_RETURN_INFORMATION] (state, data) {
		const { id, ...restData } = data
		const returnInformation = state.returnInformation
		returnInformation[id] = { ...returnInformation[id], ...restData }
		state.returnInformation = returnInformation
	},

	[SET_SEARCH_FILTERS] (state, filters) {
		state.searchFilters = filters
	},

	[SET_SUPPLIER_ORDER_SEARCH_FILTERS] (state, filters) {
		state.supplierOrderSearchFilters = filters
	},

	[SET_ORDERS_META] (state, meta) {
		state.ordersMeta = meta
	},
	[SET_RESERVATIONS_META] (state, meta) {
		state.reservationsMeta = meta
	},

	[SET_RETURNING_ORDERS_META] (state, meta) {
		state.returningOrdersMeta = meta
	},

	[SET_CARTS] (state, data) {
		state.supplierOrders = data
	},

	[SET_CARTS_META] (state, meta) {
		state.cartsMeta = meta
	},
	[SET_SUPPLIER_ORDERS] (state, data) {
		state.supplierOrders = data
	},

	[SET_SUPPLIER_ORDERS_META] (state, meta) {
		state.supplierOrdersMeta = meta
	},
	[SET_ORDERS_PRODUCTS_META] (state, meta) {
		state.ordersProductsMeta = meta
	},
	[SET_RETURNING_ORDERS_PRODUCTS_META] (state, meta) {
		state.returningOrdersProductsMeta = meta
	},
	[SET_ORDERS] (state, orders) {
		if (!orders?.length) {
			state.meta = {}
		}
		state.orders = orders
	},
	[SET_RESERVATIONS] (state, reservations) {
		if (!reservations?.length) {
			state.meta = {}
		}
		state.reservations = reservations
	},
	[SET_RETURNING_ORDERS] (state, returningOrders) {
		if (!returningOrders?.length) {
			state.meta = {}
		}
		state.returningOrders = returningOrders
	},
	[SET_ORDERS_PRODUCTS] (state, products) {
		if (!products?.length) {
			state.meta = {}
		}
		state.ordersProducts = products
	},
	[SET_RETURNING_ORDERS_PRODUCTS] (state, products) {
		if (!products?.length) {
			state.meta = {}
		}
		state.returningOrdersProducts = products
	},
	[SET_ORDER] (state, order) {
		state.order = order
	},
	[SET_RESERVATION] (state, reservation) {
		state.reservation = reservation
	},
	[SET_RETURNIG_ORDER] (state, order) {
		state.returningOrder = order
	},
	[EDIT_ORDER] (state, payload) {
		state.order = { ...state.order, ...payload }
	},
	[EDIT_RESERVATION] (state, payload) {
		state.reservation = { ...state.reservation, ...payload }
	},
	[EDIT_RETURNING_ORDER] (state, payload) {
		state.returningOrder = { ...state.returningOrder, ...payload }
	},
	[ADD_ORDER] (state, order) {
		state.orders = [...state.orders, order]
	},
	[SET_ORDER_PRODUCTS] (state, products) {
		state.products = products
	},
	[SET_ORDER_PRODUCTS_BACKUP] (state, products) {
		state.productsBackup = [...products]
	},
	[SET_RESERVATION_PRODUCTS] (state, products) {
		state.reservationProducts = products
	},
	[SET_RESERVATION_PRODUCTS_BACKUP] (state, products) {
		state.reservationProductsBackup = [...products]
	},
	[REMOVE_ORDER_PRODUCT] (state, productId) {
		state.products = state.products.filter(product => product.id !== productId)
	},
	[RESET_ORDER_PRODUCTS] (state) {
		state.products = []
	},
	[SET_RETURNING_ORDER_PRODUCTS] (state, returningProducts) {
		state.returningProducts = returningProducts
	},
	[SET_RETURNING_ORDER_PRODUCTS_BACKUP] (state, returningProducts) {
		state.returningProductsBackup = [...returningProducts]
	},
	[REMOVE_RETURNING_ORDER_PRODUCT] (state, productId) {
		state.returningProducts = state.returningProducts.filter(product => product.id !== productId)
	},
	[RESET_RETURNING_ORDER_PRODUCTS] (state) {
		state.returningProducts = []
	},
	[RESET_RETURN_INFORMATION] (state) {
		state.returnInformation = {}
	},
	[SET_ORDER_PRODUCTS_META] (state, meta) {
		state.productsMeta = meta
	},
	[SET_RESERVATION_PRODUCTS_META] (state, meta) {
		state.reservationProductsMeta = meta
	},
	[SET_RETURNING_ORDER_PRODUCTS_META] (state, meta) {
		state.returningProductsMeta = meta
	}
}
